import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabaseClient } from "../../../lib/supabase";

import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";

interface SharedAttributesInsert {
	start_date?: string | null;
	end_date?: string | null;
	reference_date?: string | null;
	hospital_number?: string | null;
	contact_id?: string | null;
}

export async function insertSharedAttributes(
	attributes: SharedAttributesInsert,
) {
	const { data, error } = await supabaseClient
		.from("shared_attributes")
		.insert(attributes)
		.select("*")
		.single();

	if (error) throw error;
	return data;
}

export const useInsertSharedAttributes = () => {
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationKey: ["insert-shared-attributes"],
		mutationFn: (attributes: SharedAttributesInsert) =>
			insertSharedAttributes(attributes),
		onError: () => {
			toast.error("Error creating shared attributes");
		},
		onSuccess: () => {
			toast.success("Shared attributes created");
		},
		onSettled: () => {
			invalidateDiaries();
		},
	});
};
